import { Center, Spinner } from "@chakra-ui/react";

const Loading = () => {
  return (
    <Center>
      <Spinner />
    </Center>
  );
};

export default Loading;
